export const appCircleFilledIcon = {
  data: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="5" fill="currentColor" fill-opacity="0.3"/>
    <circle cx="7" cy="7" r="6.5" stroke="currentColor"/>
</svg>
`,
  name: 'circle-filled',
};
